// Shared model for the weapon-skin picker variants. Mirrors the planned
// `GET /rush-mid/weapon-skins` payload (docs/superpowers/specs/2026-08-23-rushmid-weapon-skin-picker.md):
// the catalog is served per-user, locked premium skins included, so the player sees what
// an admin grant would give them.

export type SkinTier = 'public' | 'premium';

export interface WeaponSkinOption {
  /** catalog name; also the sprite file `wpn_<name>.webp` */
  name: string;
  weaponKey: string;
  title: string;
  tier: SkinTier;
  rarity: string | null;
  /** public → always true; premium → the admin granted it */
  owned: boolean;
}

/** Sprite URL for a skin name, or the stock weapon when name is null. */
export const skinSrc = (name: string | null, weaponKey: string): string =>
  name ? `/battle/wpn_${name}.webp` : `/battle/weapon_${weaponKey}.webp`;

const RARITY_COLOR: Record<string, string> = {
  covert: '#eb4b4b',
  classified: '#d32ce6',
  restricted: '#8847ff',
  milspec: '#4b69ff',
};

export const rarityColor = (rarity: string | null): string => (rarity && RARITY_COLOR[rarity]) || '#4b69ff';

/** The stock option always heads the list — every variant renders it as a real, pickable entry. */
export const STOCK: WeaponSkinOption = {
  name: '',
  weaponKey: '',
  title: 'Сток',
  tier: 'public',
  rarity: null,
  owned: true,
};
